import React from 'react';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const ExclamationIcon = ({ toolTipText = 'Notice' }) => (
  <Icon tooltip={toolTipText} iconObj={faTriangleExclamation} />
);

export default ExclamationIcon;